import styled from "styled-components";

export const Wrapper = styled.div`

  .search-container {
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;  

    .search-select {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: white;
      padding: 5px 10px;
      border-radius: 5px;
      gap: 10px;

      .icon {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        border-right: 1px solid #797979;
        height: 35px;
        color: #797979;
      }

      .select {
        width: 100%
      }
    }

    .button-reset {
      width: 200px;
      border: none;
      background: #131f28;
      color: white;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 10px;
      height: 45px;
      border-radius: 5px;

      .btn-icon {
        transform: rotate(-90deg);
      }
    }
  }

  .page-title {
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;

    .text {
      font-size: 18px;
      font-weight: 600;
      letter-spacing: 2px;
    }
  }

  .color-shade {
    height: 100px;
    width: 100px;
  }

  .content {
    margin-top: 30px;
  }

  .rotation-continer {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 20px;
  }


  .empty-user-list {
    font-size: 16px;
    padding: 10px;
    color: white;
    text-transform: uppercase;
    text-align: center;
  }
  
  .users-container {
    background: #3997b9;
    height: calc(100vh - 64px);
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;

    .top-icon {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-top: 24px;
      padding-bottom: 24px;
    }

    .available-user {
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 15px;
      overflow: auto;
      height: calc(100vh - 230px);
    }
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background-color: none;
    border: none;
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border-color: none;
  }

  .ant-select {
    color: #797979 !important;
  }
  .ant-row {
    padding: 6px 10px;
  }

  .main-section {
  }
  .cards {
    background-color: rgb(152 152 152);
    width: 350px;
    border-radius: 10px;
    margin-bottom: 10px;
  }
  .container-one {
    display: flex;
    flex-direction: column;
    margin-bottom: 0px;
    label {
      padding-left: 10px;
      font-size: 20px;
    }
    .paragraph {
      border-radius: 2px;
      border: 2px solid transparent;
      background-color: rgb(255, 255, 255);
      box-shadow: none;
      box-sizing: border-box;
      padding: 8px;
      min-height: 40px;
      margin-bottom: 8px;
      user-select: none;
      color: rgb(9, 30, 66);
      display: flex;
    }
  }

  .ant-btn {
    padding-top: 0px;
    padding-bottom: 0px;
    height: 35px;
  }

  .ant-select-selector {
    height: 35px !important;
  }
  .ant-select-selection-search,
  .ant-select-selection-item {
    margin-top: 3px;
  }

  .user-small-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 80px;
    background: #3997b9;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    position: absolute;
    bottom: 0;

    .top-icon {
      display: flex;
      flex: 0 0 15%;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #ccc;
      height: 100%;
    }

    .available-user-sm {
      display: flex;
      flex: 0 0 80%;
      align-items: flex-end;
      gap: 10px;
      overflow: auto;

      .empty-user-list-sm {

      }
    }
  }
`;
